export const PORTFOLIOS_DROPDOWN_DATA_VARIANT = {
  PROJECT: 'PROJECT',
  REQUEST: 'REQUEST'
};
